import { useSnackbar } from '@shared/utils/Snackbar'

export { useSnackbar }
